module.exports = __webpack_public_path__ + "img/galeria_salas_de_aula (3).a999ae4b.jpeg";